import Vue from "vue";
import { ERROR_CODES } from "../consts/errors";

Vue.prototype.$global = global;

// TODO: Backend should handle this logic
function getGenericErrorMessage(status) {
  switch (status) {
    case 400:
      return "general.messages.bad_request";
    case 401:
      return "general.messages.has_not_permission";
    case 403:
      return "general.messages.forbidden";
    case 404:
      return "general.messages.not_found";
    case 422:
      return "general.messages.unprocessable_entity";
    case 500:
      return "general.messages.internal_error";
    default:
      return "general.messages.error";
  }
}

// function getGenericFrontErrorMessage (message) {
//   if (message === 'static name validation') {
//     return 'general.messages.unique_name_error'
//   }
// }

export default ({ Vue }) => {
  Vue.mixin({
    methods: {
      debug: () => false,
      goBack() {
        return this.$router.go(-1);
      },
      navigateTo(target) {
        if (this.$router.currentRoute.fullPath !== target) {
          this.$router.push(target);
        }
      },
      notificationSuccess(message) {
        this.$q.notify({
          color: "positive",
          position: "top-right",
          message: message,
          classes: "t-notification"
        });
      },
      notificationError(message) {
        this.$q.notify({
          color: "negative",
          position: "top-right",
          message: message,
          icon: "report_problem",
          classes: "t-notification",
          html: true
        });
      },
      errorMessageHandler(specMessage, error, messageParams) {
        // Takes an specific message and add a generic one based on error content or response status, before show
        let message = specMessage;

        if (error && error?.response?.status === 401) {
          return;
        }

        if (error?.response?.data) {
          const errorData = error.response.data;
          //Validate fields error
          if (errorData.data && Array.isArray(errorData.data)) {
            errorData.data.forEach((data) => {
              if (data.code) {
                message = this.$i18n.t(
                  ERROR_CODES[data.code][data.field] ? ERROR_CODES[data.code][data.field] : ERROR_CODES[data.code],
                  messageParams
                );
              }
            });
          } else {
            //General code error
            if (errorData.code) {
              message = this.$i18n.t(ERROR_CODES[errorData.code], messageParams);
            }
          }
        }
        if (!message) {
          message = (message ? message + "<br/> " : "") + this.$i18n.t(getGenericErrorMessage(error?.response?.status));
        }
        return this.notificationError(message);
      },
      setBrowserLanguage() {
        const userLang = navigator.language || navigator.userLanguage;

        let language = "";
        switch (userLang) {
          case "pt-BR":
            this.$i18n.locale = "pt_BR";
            language = "pt_BR";
            break;
          case "en-US":
            this.$i18n.locale = "en_US";
            language = "en_US";
            break;
          case "es":
            this.$i18n.locale = "es_ES";
            language = "es_ES";
            break;
          case "es-ES":
            this.$i18n.locale = "es_ES";
            language = "es_ES";
            break;
          default:
            this.$i18n.locale = "en_US";
        }
        return language;
      }
    }
  });
};
